import Contact from "./pages/Contact";
import Guidance from "./pages/Guidance";
import Comment from "./pages/Comment"
import GarbageCollection from "./pages/GarbageCollection";
import MainAddress from "./pages/MainAddress";


const routes = [
 
  {
    path: 'mainaddress',
    name: "ثبت آدرس محل سکونت",
    icon: "fa fa-map-marker-alt",
    component: MainAddress,
    layout: "menu",
  },
  {
    path: 'contact',
    name: "ارتباط با پشتیبانی",
    icon: "far fa-message",
    component: Contact,
    layout: "menu",
  },

  {
    path: 'garbagecollection',
    name: "اعلام جمع آوری نخاله های شهری",
    icon: "fa fa-map-marker-alt",
    component: GarbageCollection,
    layout: "menu",
  },
  
  {
    path: 'comment',
    name: "ثبت نظرات و پیشنهادات",
    icon: "far fa-file-alt",
    component: Comment,
    layout: "menu",
  },


  {
    path: 'guidance',
    name: "فایل آموزشی",
    icon: "far fa-lightbulb",
    component: Guidance,
    layout: "menu",
  },

];

export default routes;
